import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

const tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface GameConfigurationDetailPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlDetail: string;
    urlBuildDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    },
    gameId: number;
}

export class GameConfigurationDetailPage extends PageBase<GameConfigurationDetailPageOptions> {

    private static rolesInit: string;
    private static msApi: MultiSelectApi;

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: GameConfigurationDetailPageOptions) {
        super(options);
        this.showSetValidity = this.showSetValidity.bind(this);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        var getVersionDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}?version=${rowData.Version}`);
        const getBuildVersionDetailUrl =
            (rowData: any): string => (`${options.urlBuildDetail}/${options.gameId}/${rowData.ModuleVersion}`);
        if (options.dataSwitch === "channel") {
            this._tableId = "tableChannels";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDom,
                rowId: 'Id',
                autoWidth: true,
                ordering: false,
                columns: [
                    {
                        data: 'Channel.Name',
                        className: "bold",
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                    },
                    {
                        data: "Channel.Code",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "IsEnabled",
                        render: (data: any, type: any, rowData: any) => {
                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                            var css = data === true ? 'status-enabled' : 'status-disabled';
                            return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                        }
                    },
                    {
                        data: '',
                        sortable: false,
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                    }
                ]
            };
        }

        if (options.dataSwitch === "configuration") {
            this._tableId = "tableVersions";
                this._tableOptions = {
                    url: this._options.urlList,
                    dom: tableDom,
                    rowId: 'Id',
                    autoWidth: true,
                    columns: [
                        {
                            data: 'Version',
                            className: "bold",
                            render: (data: any, type: any, rowData: any) =>
                                (`<a id='lnkName${rowData.Version}' href='${getVersionDetailUrl(rowData)}'>${data}</a>`)
                        },
                        {
                            data: 'ModuleVersion',
                            render: (data: any, type: any, rowData: any) =>
                                (`<a id='lnkGameBuildVersion${rowData.Version}' href='${getBuildVersionDetailUrl(rowData)}'>${data}</a>`)
                        },
                        {
                            data: 'CreateDate',
                            render: (data: any, type: any, rowData: any) =>
                                (`<span id='spnCreateDate${rowData.Id}'>${DateUtils.toDefaultWithTime(data)}</span>`)
                        },
                        {
                            data: 'GameVariant',
                            render: (data: any, type: any, rowData: any) =>
                                (`<span id='spnGameVariant${rowData.Id}'>${data}</span>`)
                        },
                        {
                            data: 'Rtp',
                            render: (data: any, type: any, rowData: any) =>
                                (`<span id='spnRtp${rowData.Id}'>${data}</span>`)
                        },
                        {
                            data: '',
                            sortable: false,
                            render: (data: any, type: any, rowData: any) =>
                                (`<a id='lnkDetail${rowData.Version}' href='${getVersionDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                        }
                    ],
                    order: [[0, "desc"]]
                };
        }
    }

    init(): void {
        GameConfigurationDetailPage.msApi = new MultiSelectApi('roles');
        GameConfigurationDetailPage.rolesInit = GameConfigurationDetailPage.msApi.getSelectionValues();

        const btnValidity = Utils.getJQueryById("btnValidity");
        btnValidity.on("click", this.showSetValidity);

        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        GameConfigurationDetailPage.msApi.setSelectionValues(GameConfigurationDetailPage.rolesInit);

        $(label).closest(".form-group").removeClass("gray");
    }

    private showSetValidity() {
        $('#validitySettings').removeAttr("hidden");
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/GameConfigurationDetailPage.ts
 **/